/**
 * Měkký (advisory) zámek souběžné editace projektu — Epic 14 kap. 3
 * (doc/epic-14-uzivatele-a-opravneni.md). Konstanty žijí ve shared balíku,
 * aby backend (TTL) a frontend (heartbeat interval) nemohly rozejít.
 */
/** Po jak dlouhé nečinnosti (bez heartbeatu) lease sama vyexpiruje. */
export const EDIT_LEASE_TTL_MS = 90_000;
/** Jak často klient obnovuje lease heartbeatem — bezpečně pod TTL. */
export const EDIT_LEASE_HEARTBEAT_MS = 20_000;
//# sourceMappingURL=lease.js.map